import AclName from '../../acl/AclName';
import model from '../../models-v2/staff/leave';
import beforeStaffLeavesEnterMiddleware from '../../router/beforeStaffLeavesEnterMiddleware';
import routeName from '../route-name';

export default [
  {
    beforeEnter: beforeStaffLeavesEnterMiddleware,
    path: '/leaves',
    name: routeName.leaves.index,
    components: {
      default: () => import('../../pages/data-grid.vue'),
      topRightSection: () => import('../../pages/staff/leaves/LeaveTopRightSection.vue'),
    },
    meta: {
      acl: AclName.StaffPageLeavesList,
      breadcrumb: [
        { title: 'Nieobecności', url: '/leaves' },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    beforeEnter: beforeStaffLeavesEnterMiddleware,
    path: '/leaves/add',
    name: routeName.leaves.store,
    component: () => import('../../pages/staff/leaves/LeavesCreateView.vue'),
    meta: {
      acl: AclName.StaffPageLeavesAdd,
      breadcrumb: [
        { title: 'Nieobecności', url: '/leaves' },
      ],
    },
  },
  {
    beforeEnter: beforeStaffLeavesEnterMiddleware,
    path: '/leaves/edit/:id(\\d+)',
    name: routeName.leaves.edit,
    component: () => import('../../pages/staff/leaves/LeavesEditView.vue'),
    meta: {
      acl: AclName.StaffPageLeavesEdit,
      breadcrumb: [
        { title: 'Nieobecności', url: '/leaves' },
      ],
    },
    props: (route) => ({ id: Number(route.params.id) }),
  },
  {
    path: '/leaves/warning-no-employees-view.vue',
    name: routeName.leaves.warningNoEmployees,
    component: () => import('../../pages/staff/leaves/leaves-warning-no-employees-view.vue'),
    meta: {
      acl: AclName.StaffPageLeavesList,
      breadcrumb: [
        { title: 'Nieobecności', url: '/leaves' },
      ],
    },
  },
];
